// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ttojd {\n  border: none !important;\n}\n\n.ttojd svg {\n  /* Matches font awesome xl variant size but set here to override button svg styles */\n  width: var(--schoolinks-icon-lg) !important;\n  height: var(--schoolinks-icon-lg) !important;\n  color: var(--color-white);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "ttojd"
};
export default ___CSS_LOADER_EXPORT___;
